<template>
	<span><span v-b-tooltip.hover.bottom :title="createdFormatted" style="display: inline-block; cursor: default;">Udgivet {{createdDistance}}<template v-if="updatedAtRelative">,&nbsp;</template></span><span v-if="updatedAtRelative" style="display: inline-block;">senest opdateret {{updatedAtRelative}}</span></span>
</template>

<script>
import { VBTooltip } from "bootstrap-vue";
import { parseISO, isFuture, format, formatDistanceToNow, formatRelative } from "date-fns";
import da from "date-fns/locale/da";

export default {
	props: {
		post: {
			required: true,
		},
	},
	directives: {
		'b-tooltip': VBTooltip,
	},
	computed: {
		created() {
			return (this.post.published && parseISO(this.post.published)) ? parseISO(this.post.published) : new Date(this.post.createdAt)
		},
		createdDistance() {
			if (this.created && this.created < new Date()) {
				return (isFuture(this.created) ? "" : "for ") + formatDistanceToNow(this.created, {locale: da, addSuffix: true});
			}
			return "lige nu";
		},
		createdRelative() {
			if (this.created && this.created < new Date()) {
				return formatRelative(this.created, new Date(), {locale: da, weekStartsOn: 1});
			}
			return false;
		},
		createdFormatted() {
			if (this.created && this.created < new Date()) {
				return format(this.created, "yyyy-MM-dd' kl. 'HH:mm");
			}
			return "I dag";
		},

		updated() {
			let created = this.created;
			return (this.post.updated && parseISO(this.post.updated)) ? parseISO(this.post.updated) : created;
		},

		updatedAtDistance() {
			if (this.updated > this.created) {
				return formatDistanceToNow(new Date(this.updated), {locale: da, addSuffix: true});
			}
			return false;
		},
		updatedAtRelative() {
			if (this.updated > this.created) {
				return formatRelative(new Date(this.updated), new Date(), {locale: da, weekStartsOn: 1});
			}
			return false;
		},
		updatedAtFormatted() {
			if (this.updated > this.created) {
				return format(new Date(this.updated), "yyyy-MM-dd' kl. 'HH:mm");
			}
			return false;
		},
	}
}
</script>